import { z } from 'zod';
import { requiredString } from '../helpers';
// Max timeout constants
export const MAX_TIMEOUT_SECONDS = {
    toolCall: 30, // In-call/pre-call: 30 seconds max
    postCall: 60
};
/**
 * Returns a validator with max timeout based on context (isToolCall)
 * @param isToolCall - true for in-call/pre-call workflows (30s max), false for post-call workflows (60s max)
 */
export const createLLM_LLM_2_ConfigValidator = (isToolCall) => {
    const maxSeconds = isToolCall ? MAX_TIMEOUT_SECONDS.toolCall : MAX_TIMEOUT_SECONDS.postCall;
    return z.object({
        prompt: requiredString('Prompt is required'),
        outputSchema: z.record(z.string(), z.any()).optional(),
        proMode: z.boolean().optional(),
        advanced: z
            .object({
            timeoutSeconds: z
                .number({ message: 'Timeout must be a number' })
                .min(1, { message: 'Timeout must be at least 1 second' })
                .max(maxSeconds, { message: `Timeout must be at most ${maxSeconds} seconds` })
                .optional()
        })
            .optional()
    });
};
/**
 * LLM LLM v2 Configuration Validator (default: post-call context with 60s max)
 */
export const LLM_LLM_2_ConfigValidator = createLLM_LLM_2_ConfigValidator(false);
//# sourceMappingURL=llm-llm-2.js.map